import { makeAutoObservable, runInAction } from 'mobx';
import { Event, EventsFilters, FetchEventsParams } from 'types';
import { AxiosMethod, LoadingStatus } from 'enums';
import { NetworkRequestHandler } from 'http/NetworkRequestHandler';
import {
  API_V1_ADMIN_MEASUREMENT,
  API_V1_ADMIN_MEASUREMENT_EXCEL,
} from 'consts';
import {
  createLinkElementForBlob,
  removeEmptyArraysFromObj,
  removeUndefinedFromObj,
} from 'utils/functions';

class ExportEventsStore {
  events: Event[] = [];

  totalPages: number = 0;

  filters: EventsFilters = {};

  status: LoadingStatus = LoadingStatus.IDLE;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchEvents(params?: FetchEventsParams) {
    this.events = [];
    this.status = LoadingStatus.PENDING;
    const { content, totalPages } = await NetworkRequestHandler.sendRequest({
      url: API_V1_ADMIN_MEASUREMENT,
      method: AxiosMethod.GET,
      params: {
        ...removeEmptyArraysFromObj(removeUndefinedFromObj(params as object)),
      },
    });
    runInAction(() => {
      this.events = content;
      this.totalPages = totalPages;
      this.status = LoadingStatus.DONE;
    });
  }

  async fetchEventsExcel() {
    const file = await NetworkRequestHandler.sendRequest({
      url: API_V1_ADMIN_MEASUREMENT_EXCEL,
      method: AxiosMethod.POST,
      data: {
        filters: removeEmptyArraysFromObj(removeUndefinedFromObj(this.filters)),
        sort: {
          sortDirection: 'ASC',
        },
      },
      responseType: 'blob',
    });
    createLinkElementForBlob(file, 'exportEventsExcel');
  }

  setFilter(filterParams: EventsFilters) {
    this.filters = { ...this.filters, ...filterParams };
  }

  cleanFilter() {
    this.filters = {};
  }
}

export default new ExportEventsStore();
